module.exports = __webpack_public_path__ + "img/sa5.162e6cd9.png";